module.exports = __webpack_public_path__ + "static/media/banjo.8b07c56b.jpg";